import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circleco/compass/components/Icon";

import { t } from "@/i18n-js/instance";

interface RightSideIndicatorsProps {
  className?: string;
  currentParticipant: {
    muted?: boolean;
  };
  hasUnreadMessages: boolean;
  isPinned: boolean;
}

export const RightSideIndicators = ({
  isPinned,
  currentParticipant,
  hasUnreadMessages,
  className,
}: RightSideIndicatorsProps) => (
  <div
    className={classNames("flex h-5 flex-row items-center gap-1.5", className)}
  >
    {isPinned && (
      <Icon
        name="pin"
        aria-label={t("messaging.pinned_message")}
        aria-hidden={false}
        size="sm"
        color="tertiary"
      />
    )}
    {currentParticipant?.muted ? (
      <Icon
        name="bell-mute"
        aria-label={t("header_v3.muted")}
        size="sm"
        color="tertiary"
      />
    ) : (
      hasUnreadMessages && (
        <span className="bg-royal-blue-400 inline-block size-2 rounded-full ml-1.5" />
      )
    )}
  </div>
);
